import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { DealerPartsListviewModel } from '../business-entities/dealer-parts-list-view-model';
import { PartsListViewModel } from '../business-entities/parts-list-view-model';

@Injectable({
  providedIn: 'root'
})
export class PartsDataService {

  constructor(private dataProvider: DataService) { }


  addParts(model: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.AddParts, model).toPromise();
  }
  async getDealerPartsList(DealerId: string): Promise<GenericResponse<DealerPartsListviewModel>> {
    return this.dataProvider.Get<GenericResponse<DealerPartsListviewModel>>(Urls.GetDealerListForPart, DealerId)
      .toPromise();
  }
  async getPartsList(cost : string,languageCode:string): Promise<GenericResponse<Array<PartsListViewModel>>> {
    return this.dataProvider.Get<GenericResponse<Array<PartsListViewModel>>>(Urls.GetPartsList, cost,languageCode).toPromise();
  }

  async getPartById(partNumber: string): Promise<any> {
    return this.dataProvider.Get<any>(Urls.GetPartById, partNumber).toPromise();
  }

  async GetPartSalesPriceList(model: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any[]>>(Urls.GetPartSalesPriceCalculation, model).toPromise();
  }
  async GetLaborChargingGroupPrice(model: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any[]>>(Urls.GetLaborChargingGroupPrice, model).toPromise();
  }

  async getParts(model: any): Promise<any> {
    return  this.dataProvider.Post<GenericResponse<any>>(Urls.GetParts, model).toPromise();
  }

  async GetPartLocation(model: any): Promise<any> {
    return  this.dataProvider.Post<GenericResponse<any>>(Urls.GetPartLocation, model).toPromise();
  }
  async GetAlternativeParts(model: any): Promise<any> {
    return  this.dataProvider.Post<GenericResponse<any>>(Urls.GetAlternativeParts, model).toPromise();
  }
  async GetReplacementParts(model: any): Promise<any> {
    return  this.dataProvider.Post<GenericResponse<any>>(Urls.GetReplacementParts, model).toPromise();
  }
  async GetAdditionalParts(model: any): Promise<any> {
    return  this.dataProvider.Post<GenericResponse<any>>(Urls.GetAdditionalParts, model).toPromise();
  }
  async GetFinalPartsWithAdditional(model: any): Promise<any> {
    return  this.dataProvider.Post<GenericResponse<any>>(Urls.GetFinalPartsWithAdditional, model).toPromise();
  }
  async GetInventoryParts(model:any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetInventoryParts,model).toPromise();
  }
  async GetPartDetails(model: any): Promise<any> {
    return await this.dataProvider.Post<GenericResponse<any>>(Urls.GetPartDetails, model).toPromise();
  }
  async GetMultiInventoryParts(model:any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetMultiInventoryParts,model).toPromise();
  }
  async GetPartCostPriceDetails(model:any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetPartCostPriceDetails,model).toPromise();
  }

  async GetItemStatusAndInventoryList(model:any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetItemStatusAndInventory,model).toPromise();
  }
}
